///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>

///<reference path="../collections/report-manufacturers.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class InventoryDistributorsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected distributors: InventoryDistributorsCollection;

        public totalSelectedMessage: string;
        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.distributors;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.filters = [new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_DISTRIBUTORS' })];
            this.distributors = new InventoryDistributorsCollection(this.model[this.properties[0]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.distributors.addFilters(...this.filters as IInteractiveFilter[])

            this.title = 'LABEL_DISTRIBUTOR';
            this.allSelectedLabel = 'LABEL_ALL_DISTRIBUTORS';
            this.totalSelectedMessage = 'LABEL_TOTAL_DISTRIBUTORS_SELECTED';
        }
    }
}
